module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNy40NiAxNC43MyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDM3NjQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMy43MywxLDI2LjQ2LDEzLjczIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuNzMsMSwxLDEzLjczIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/generic/arrow_up_darkblue.svg
// module id = CHTt
// module chunks = 13